import { raceTypes, timePeriods, selection } from '../../utils/filter';

const getRTOptions = (typeCode) => {
    const { jumps, flat } = raceTypes.course;
    switch (typeCode) {
        case 'J':
        case 'P': return [jumps];
        case 'B': return [flat, jumps];
        default : return [flat];
    }
};

const raceTypeFactory = (code, currentRaceType) => ({
    options: selection.setSelected(getRTOptions(code), currentRaceType),
    title: 'race type',
});

export const timePeriodFactory = (raceType, countryCode) => {
    const currentYear = timePeriods.getCurrentSeasonEndYear(raceType, countryCode);

    const options = [
        timePeriods.getLast5(currentYear, raceType),
        timePeriods.getCurrent(currentYear, raceType),
        ...timePeriods.getPeriods(currentYear - 1, currentYear - 5, raceType),
    ];

    options[0].selected = true;

    return {
        title: 'time period',
        options,
        createdBy: { raceType, countryCode },
    };
};

const categories = (currentRaceType, countryCode, typeCode) => ({
    raceType: raceTypeFactory(typeCode, currentRaceType),
    timePeriod: timePeriodFactory(currentRaceType, countryCode),
});

export default categories;



// WEBPACK FOOTER //
// ./src/js/course/favourites/categories.js